export default "__VITE_ASSET__CFoXa9ZL__"